import React, { useEffect, useState, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface RegistrationPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export const RegistrationPopup: React.FC<RegistrationPopupProps> = ({
  isOpen,
  onClose
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-117">
      <div ref={popupRef} className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 relative" data-id="element-118">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" aria-label="Close" data-id="element-119">
          <XIcon className="w-6 h-6" data-id="element-120" />
        </button>
        <h3 className="text-xl font-bold text-blue-800 mb-4 text-center" data-id="element-121">
          Reserveer Je Gratis Plek
        </h3>
        <div className="flex justify-center items-center mb-4" data-id="element-122">
          <div data-id="element-123">
            <iframe src="https://app.webinargeek.com/embed/5e7c8763-630c-465a-9315-12067b2aa215?cst=meta" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: '1px solid #ccc',
            borderRadius: '25px'
          }} data-id="element-124" />
            <div className="tve_iframe_cover" data-id="element-125"></div>
          </div>
        </div>
      </div>
    </div>;
};